import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonService } from '../common.service';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private common: CommonService
  ) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const clonedReq = this.handleRequest(req);
    // this.spinner.show();
    return next.handle(clonedReq);
  }
  handleRequest(req: HttpRequest<any>) {
    let token: any = 'NA';
    let viewType: any = '';

    if (localStorage.getItem('token')) {
      token = localStorage.getItem('token');
    }

    const setViewTypeRaw = localStorage.getItem('setViewType');
    if (setViewTypeRaw) {
      try {
        viewType = JSON.parse(setViewTypeRaw);
      } catch (e) {
        viewType = setViewTypeRaw;
      }
    }

    if (!viewType || viewType === 'NA') {
      const viewTypeRaw = localStorage.getItem('viewType');
      if (viewTypeRaw) {
        try {
          const parsed = JSON.parse(viewTypeRaw);
          if (Array.isArray(parsed) && parsed.length > 0 && parsed[0]?.value) {
            viewType = parsed[0].value;
            localStorage.setItem('setViewType', JSON.stringify(viewType));
          }
        } catch (e) {}
      }
    }

    if (!viewType || viewType === 'NA') {
      viewType = 'apptunix_ondemand';
      localStorage.setItem('setViewType', JSON.stringify('apptunix_ondemand'));
    }

    let authReq;
    authReq = req.clone({
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        viewtype: viewType,
        Authorization: `${token}`,
        encrytedkey: "qwertyuiopasdfghjkwertysdfwerdcfcssrexrt45573ds423",
      }),
    });
    if (
      (req.method.toLowerCase() == 'post' ||
        req.method.toLowerCase() == 'put') &&
      req.body instanceof FormData
    ) {
      authReq = req.clone({
        headers: new HttpHeaders({
          viewtype: viewType,
          Authorization: `${token}`,
          encrytedkey: "qwertyuiopasdfghjkwertysdfwerdcfcssrexrt45573ds423",
        }),
      });
    }
    return authReq;
  }
}
